<template>
    <div>
        <div class="card-body" style="background-color: white;">
                <div class="container">
                    <div class="row">

                        <div class="col-md-4 float-left text-right">
                            <img style="width: 150px; margin-top: 35px;" :src="returnUrl('followup')">
                        </div>

                        <div class="col-md-4 float-left text-center">
                            <img class="and-logic-logo mt-4 pt-3" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/and-logic-new.png">
                        </div>
                        <div class="col-md-4 float-left text-left">
                            <img class="mt-50" style="width: 150px;" :src="returnUrl(connectedErpIntegration)">
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <label class="my-4">Module Mapping </label>
                        </div>
                        <div class="col-12" style="">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th class="col-3">Followup Module</th>
                                        <th class="col-3 capitalize">{{ connectedErpIntegrationName }} Module</th>
                                        <th class="col-3" >Field Mapping</th>
                                        <th class="col-1">ON/OFF</th>
                                        <th class="col-2">Import</th>
                                        <th class="col-1 text-center">Add/Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(module, moduleIndex) in moduleMappings" :key="moduleIndex">
                                        <td>
                                            <div v-if="module.id !== 0" class="capitalize">
                                               {{module.followUp.replace(/-/g , ' ')}}
                                            </div>
                                            <b-form-select
                                                v-else
                                                v-model="module.followUp"
                                                :options="followUpObjects"
                                                value-field="value"
                                                text-field="label"
                                                disabled-field="disabled"
                                                @change="changeModule(module, 'followup', moduleIndex)"
                                            ></b-form-select>
                                        </td>
                                        <td>
                                            <div v-if="module.id !== 0">
                                                {{module.thirdPartyLabel}}
                                            </div>
                                            <b-form-select
                                                v-else
                                                v-model="module.thirdParty"
                                                :options="thirdPartyObjects"
                                                value-field="value"
                                                text-field="label"
                                                disabled-field="disabled"
                                                @change="changeModule(module, 'thirdParty', moduleIndex)"
                                            ></b-form-select>
                                        </td>
                                        <td>
                                           <div class="btn-link cursor-pointer" @click="viewFieldsMapping(module, moduleIndex)">View Mapped Fields</div>
                                        </td>
                                        <td>
                                            <span v-if="checkDisabledModuleStatus(module)" :title="'Map all required fields within the module to turn this on'" class="checkbox-status-disabled-tooltip hover:cursor-pointer">
                                                <b-form-checkbox :disabled="checkDisabledModuleStatus(module)" v-model="module.status" switch @change="updateModuleStatus(module)"></b-form-checkbox>
                                            </span>
                                            <span v-else>
                                                <b-form-checkbox :disabled="checkDisabledModuleStatus(module)" v-model="module.status" switch @change="updateModuleStatus(module)"></b-form-checkbox>
                                            </span>
                                        </td>
                                        <td v-if="module.fieldMappings.length === 0">
                                            <button
                                                disabled="disabled"
                                                v-if="module.followUp === 'Project' && module.thirdParty === 'CE_jobs'"
                                                type="button"
                                                class="btn btn-primary"
                                                @click.prevent="openImportJobsModal(module)"
                                                title="Please map the mandatory fields to import jobs">
                                                Import Jobs
                                            </button>
                                        </td>
                                        <td v-else>
                                            <button
                                                v-if="module.followUp === 'Project' && module.thirdParty === 'CE_jobs'"
                                                type="button"
                                                class="btn btn-primary"
                                                @click.prevent="openImportJobsModal(module)">
                                                Import Jobs
                                            </button>
                                        </td>
                                        <td class="text-center">
                                            <button type="button" class="btn btn-danger"
                                                    @click.prevent="manageModuleDeletion(module, moduleIndex)">
                                                Delete
                                            </button>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                            <div v-if="moduleMappings.length < 2" class="w-100 text-right">
                               <button type="button" class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav rounded-full hover:text-white px-10 md:px-3 border-r-1 text-followup-nav"
                                        @click.prevent="addModuleMapping()">
                                    Add Mapping
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
        <b-modal id="fieldsMappingModal" size="xl" class="tooltips-direction-class"  title="Field Mapping" :hide-footer="true" v-model="showFieldsMapping" no-close-on-backdrop @hide="onModalHide()">
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <button class="btn btn-link" @click="showFieldsMapping = false">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </template>
            <div id="loadingOverlayFetchVistaFields">
                <div class="cv-spinner">
                    <span class="spinner"></span>
                    <span class="text-white ml-4 text-xl ">{{ loadingMessage}}</span>
                </div>
            </div>
            <div class="container">
<!--                <h3>Field Mapping </h3>-->
                <div class="row">
                    <div class="col-md-4 float-left text-center flex justify-content-center align-items-center font-weight-bold capitalize">
                        {{ selectedModule.followUp.replace(/-/g , ' ') }}
                    </div>

                    <div class="col-md-4 float-left text-center">
                        <img style="width: 70px" :src="returnUrl('one-way-followup-latest')">
                    </div>
                    <div class="col-md-4 float-left text-center flex justify-content-center align-items-center font-weight-bold">
                        {{ selectedModule.thirdPartyLabel}}
                    </div>
                </div>
                <div>
                    <table class="table table-bordered mt-4">
                        <thead>
                            <tr>
                                <th class="col-3">Followup Field</th>
                                <th class="col-2 text-center">Direction</th>
                                <th class="col-3 capitalize">{{ connectedErpIntegrationName }} Field</th>
                                <th class="col-1">ON/OFF</th>
                                <th class="col-1">Add/Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(fieldItem, index) in selectedModuleFieldMappings" :key="fieldItem.id" :id="fieldItem.id">
                                <td>
                                    <div v-if="fieldItem.id !== 0 && editingModuleFieldIndex !== index">
                                        {{fieldItem.followUpLabel}} <span v-if="selectedModule.followUp == 'Company' && fieldItem.followUpObject == 'CompanyContact'"> (Contact)</span>
                                    </div>
                                    <b-form-select
                                        v-else
                                        class="mb-3"
                                        v-model="fieldItem.followUp"
                                        @change="changeFields(fieldItem, 'followup', index)"
                                        disabled-field="disabled"
                                        filter>
                                        <b-form-select-option-group v-for="(group, index) in computedFollowUpFields" :label="group.label" :key="index">
                                            <b-form-select-option
                                                v-for="(option, optIndex) in group.options"
                                                :key="optIndex"
                                                :value="option.value">
                                                {{ option.label }}
                                            </b-form-select-option>
                                        </b-form-select-option-group>
                                    </b-form-select>
                                </td>
                                <td class="text-center">
                                    <button v-if="fieldItem.canChangeDirection && selectedModule.direction == 'two-ways'"
                                            :disabled="connectedErpIntegration === 'foundationNew' && fieldItem.followUpLabel === 'Auto-generated Job # based on foundationNew Job# (N/A to alphanumeric)'"
                                            @mouseenter="returnUrlHoverField(fieldItem, index)" @mouseleave="returnUrlDirectionField(fieldItem, index)"  type="button" class="tooltips-direction-class" data-toggle="tooltip" data-placement="top" title="" @click="changeModuleFieldDirection(fieldItem, index)">
                                        <img :id="'directionModuleUrlField'+fieldItem.id" style="width: 30px" :src="fieldItem.directionUrl">
                                    </button>

                                    <img class="tooltips-direction-class" v-else-if="fieldItem.canChangeDirection && selectedModule.direction !== 'two-ways'" style="width: 30px" :src="fieldItem.directionUrl" data-toggle="tooltip" data-placement="top" :title="returnToolTip(fieldItem.direction)">

                                    <img v-else class="tooltips-direction-class" style="width: 30px" :src="returnUrl('one-way-followup-latest')" data-toggle="tooltip" data-placement="top"  :title="'Data cannot be pushed to this ' +connectedErpIntegration+ ' field. It can only be pulled in'">

<!--                                        <button v-if="fieldItem.is_dropdown_field && fieldItem.is_third_party_dropdown_field" @click.prevent="mapDropdownFields(fieldItem, index)" class="btn btn-sm btn-success ml-3">Map fields</button>-->
<!--                                        <button v-else-if="connectedErpIntegration == 'spectrum' && fieldItem.followUpObject === 'Project' && fieldItem.followUp.value == 'job_number' && fieldItem.thirdParty == 'number'" @click.prevent="showProjectCustomFieldDropdown(fieldItem)" class="btn btn-sm btn-success ml-3">Map fields</button>-->
<!--                                        <button v-else-if="fieldItem.followUpLabel === 'Auto-generated Job # based on foundationNew Job# (N/A to alphanumeric)'-->
<!--                                                 && fieldItem.followUpObject === 'Project' && fieldItem.thirdPartyLabel ==='job_no'"-->
<!--                                                @click.prevent="mapDropdownFields(fieldItem, index)" class="btn btn-sm btn-success ml-3">Map fields</button>-->
                                </td>
<!--                                <td v-else class="text-center">-->
<!--                                    <button v-if="fieldItem.canChangeDirection"  type="button" @click="changeModuleFieldDirection(fieldItem)">-->
<!--                                        <img style="width: 30px" :src="returnUrl(fieldItem.direction)">-->
<!--                                    </button>-->
<!--                                    <img v-else style="width: 30px" :src="returnUrl('one-way-followup')">-->

<!--                                        <button v-if="fieldItem.is_dropdown_field && fieldItem.is_third_party_dropdown_field" @click.prevent="mapDropdownFields(fieldItem, index)" class="btn btn-sm btn-success ml-3">Map fields</button>-->
<!--                                </td>-->
                                <td>
                                    <div v-if="fieldItem.id !== 0 && editingModuleFieldIndex !== index">
                                        {{ formattedLabel(fieldItem)}}
                                    </div>
                                    <b-form-select
                                        v-else
                                        v-model="fieldItem.thirdParty"
                                        :options="thirdPartyFields"
                                        value-field="value"
                                        text-field="labelFormatted"
                                        @change="changeFields(fieldItem, 'thirdParty', index)"
                                        :disabled="manageFieldDisableForRequiredFields(fieldItem)"
                                        filter
                                    ></b-form-select>
                                </td>
                                <td>
                                    <b-form-checkbox
                                        v-model="fieldItem.status"
                                        :disabled="manageFieldDisableForRequiredFields(fieldItem)"
                                        :class="manageFieldDisableForRequiredFields(fieldItem) ? 'disabled-opacity' : ''"
                                        switch>
                                    </b-form-checkbox>
                                </td>
                                <td>
                                    <div v-if="fieldItem.id !== 0 && editingModuleFieldIndex !== index" class="flex justify-content-between">
                                        <button type="button" class="btn btn-warning btn-sm"  @click.prevent="editModuleField(index)">
                                            Edit
                                        </button>
                                        <button :title="isFieldRequiredToolTip(fieldItem)"
                                                data-toggle="tooltip" data-placement="top"
                                                type="button"
                                                class="btn btn-danger btn-sm tooltip-delete-field-mapping"
                                                @click.prevent="removeModuleField(index)"
                                                :disabled="manageFieldDisableForRequiredFields(fieldItem)">
                                            Delete
                                        </button>
                                    </div>
                                    <div v-else>
                                        <div class="flex justify-content-between">
                                            <button v-if="editingModuleFieldIndex === index" type="button" class="btn btn-primary btn-sm"  @click.prevent="addModuleField(index)">
                                                Update
                                            </button>
                                            <button v-else type="button" class="btn btn-primary btn-sm"  @click.prevent="addModuleField(index)">
                                                Add
                                            </button>
                                            <button :title="isFieldRequiredToolTip(fieldItem)"
                                                    data-toggle="tooltip" data-placement="top"
                                                    type="button"
                                                    class="btn btn-danger btn-sm tooltip-delete-field-mapping"
                                                    @click.prevent="removeModuleField(index)"
                                                    :disabled="manageFieldDisableForRequiredFields(fieldItem)">
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="selectedModuleFieldMappings.length < thirdPartyFields.length" class="w-100 text-right">
                        <button type="button" class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav rounded-full hover:text-white px-10 md:px-3 border-r-1 text-followup-nav"
                                @click.prevent="addModuleFieldMappingData()">
                            {{ selectedModuleFieldMappings.length === 0 ?'Map field': 'Map another field' }}
                        </button>
                    </div>

<!--                    <div v-if="selectedModuleFieldMappings.length > 0 && showSaveFieldsButton" class="w-100 text-right mt-3">-->
<!--                        <button type="button" class="btn btn-primary"-->
<!--                                @click.prevent="saveModuleFields()">-->
<!--                            Save-->
<!--                        </button>-->
<!--                    </div>-->
                    <div class="text-md mb-3">{{ fieldMappingNote }}</div>
                    <div class="text-sm text-danger" v-if="fieldMappingError">{{fieldMappingError}}</div>
                </div>
            </div>
        </b-modal>

        <div class="modal" tabindex="-1" role="dialog" id="importCustomerConfirmationModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">Import all Vista customers?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will import all the customers from Vista, as per the fields mapped. Do you want to proceed?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeImportCustomersModal()">No</button>
                        <button type="button" class="btn btn-primary" @click.prevent="importCustomers()">Yes</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" tabindex="-1" role="dialog" id="importJobConfirmationModal">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">Import all <span class="capitalize">{{ this.connectedErpIntegration }}</span> Jobs?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Would you like to update any Jobs that are already synced with projects on Followup, based on the fields mapped</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click.prevent="importJobs(true)">Yes</button>
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="importJobs(false)">No</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="importJobFoundationConfirmationModal">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">Import all Foundation Jobs?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Would you like to update any Jobs that are already synced with projects on Followup, based on the fields mapped ?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click.prevent="importFoundationJobs(true)">Yes</button>
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="importFoundationJobs(false)">No</button>
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="mapDropdownFieldOptions" size="lg" centered title="Map Dropdown" :hide-footer="true" v-model="showMapFieldOptions" >
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <button class="btn btn-link" @click="showMapFieldOptions = false">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </template>
            <div id="loadingOverlayFetchingFieldOptions">
                <div class="cv-spinner">
                    <span class="spinner"></span>
                    <span class="text-dark ml-4 text-xl ">{{loadingDropdownOptionsMessage}}</span>
                </div>
            </div>
            <div class="container">

                <div class="mapping-table">
                    <table class="table table-bordered mt-4">
                        <thead>
                        <tr>
                            <th class="col-3">{{ selectedMappingDropdownField.followUpLabel }}</th>
                            <th class="col-3">{{ selectedMappingDropdownField.thirdPartyLabel }} ({{connectedErpIntegrationName}})</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in moduleFieldDropdowns">
                            <td>
                                <b-form-select
                                    v-model="item.followup_field_id"
                                    :options="followUpDropdownOptions"
                                    value-field="followup_field_id"
                                    text-field="name"
                                    @change="changeDropdownMappingField(index, item, 'follow_up')"
                                ></b-form-select>
                            </td>
                            <td>
                                <b-form-select
                                    v-model="item.agave_field_id"
                                    :options="thirdPartyDropdownOptions"
                                    value-field="agave_field_id"
                                    text-field="name"
                                    @change="changeDropdownMappingField(index, item, 'thirdParty')"
                                ></b-form-select>
                            </td>

                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="w-100 text-right">
                    <button type="button" class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-10 md:px-3 border-r-1 text-followup-nav"
                           @click.prevent="saveDropdownOptions()" >
<!--                        check if all field have third_party_id-->
                        Save
                    </button>
                </div>

            </div>
        </b-modal>

        <b-modal id="mapCustomFieldForJobNumber" size="lg" centered title="Map Dropdown" :hide-footer="true" v-model="showCustomFieldsDropdownForJobNumber" >
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <button class="btn btn-link" @click="showCustomFieldsDropdownForJobNumber = false">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </template>
            <!-- <div id="loadingOverlayFetchingFieldOptions">
                <div class="cv-spinner">
                    <span class="spinner"></span>
                    <span class="text-dark ml-4 text-xl ">{{loadingDropdownOptionsMessage}}</span>
                </div>
            </div> -->
            <div class="container">

                <div class="mapping-table">
                    <table class="table table-bordered mt-4">
                        <thead>
                        <tr>
                            <th class="col-3">{{ selectedMappingDropdownField.followUpLabel }}</th>
                            <th class="col-3">{{ selectedMappingDropdownField.thirdPartyLabel }} ({{connectedErpIntegrationName}})</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>
                                <select class="custom-select">
                                    <option selected>{{ selectedMappingDropdownField.followUpLabel }}</option>
                                </select>
                            </td>
                            <td>
                                <select class="custom-select" @change="markProjectCustomFieldToShowJobNumber" v-model="selectedProjectTextCustomField">
                                    <option
                                        v-for="field in projectTextCustomFields"
                                        :value="field.id"
                                    >{{ field.label_value }}</option>
                                </select>
                            </td>

                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="w-100 text-right">
                    <button type="button" class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-10 md:px-3 border-r-1 text-followup-nav"
                           @click.prevent="showCustomFieldsDropdownForJobNumber = false" >
                        Save
                    </button>
                </div>

            </div>
        </b-modal>
    </div>
</template>


<script>

import axios from 'axios';
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import {
    erpObjectOptions,
    erpProjectFields,
    erpProjectChangeOrderFields,
    erpCompanyFields,
    erpContactFields,
    erpResidentialContactFields,
    erpAgaveFields,
    erpOneWayFields,
    erpFieldsToHide,
    spectrumFieldLabelsMapping,
    erpFoundationExtendFields, erpFoundationExtendFieldsForContact,projectContactField
} from "../../../constants"

export default {

    name: 'erp-integration-computerEase-field-settings',
    components: {Multiselect},
    props: ['team', 'bucketUrl', 'mappingData', 'connectedErpIntegration'],
    data() {
        return {
            erpIntegrationId: 0,
            direction:'two-ways',
            fieldDirection:'two-ways',

            // Data from constants.js
            agaveFields: erpAgaveFields,
            objectOptions: erpObjectOptions,
            thirdPartyObjects: [],
            followUpObjects: [],
            followUpFields: {
                projectFields :erpProjectFields,
                projectChangeOrderFields :erpProjectChangeOrderFields,
                companyFields :erpCompanyFields,
                companyExtendedFields :erpFoundationExtendFields,
                contactFields :erpContactFields,
                residentialContactFields :erpResidentialContactFields,
                projectCustomFields: [],
                companyCustomFields: [],
                contactCustomFields: [],
                changeOrderCustomFields: [],
                salesBehaviors: [],
                projectContact: projectContactField,
                companyContactExtendedFields : erpFoundationExtendFieldsForContact,
                recordDetailCustomFields: []
            },
            projectTextCustomFields: [],
            selectedProjectTextCustomField: 0,

            // this will hold the modules mappings with fields and their dropdown options
            moduleMappings : [],
            // this will hold the field mapping data for the selected module for detail or edit
            selectedModule: {
                followUp: '',
                direction: 'two-ways',
                directionUrl: '',
                thirdParty: '',
                thirdPartyLabel: '',
                status: true,
                fieldMappings: [],
                erp_integration_field_id: '',
                erp_integration_id: ''
            },
            selectedModuleIndex: null,
            selectedModuleFieldMappings: [],
            // to show the field mappings modal
            showFieldsMapping: false,
            showSaveFieldsButton: false,
            followUpFieldsOptions: [],


            thirdPartyFields: [],

            fieldMappingError: null,
            loadingMessage: 'Fetching fields',
            isAddButtonDisable: false,
            showSyncedFieldOptions: false,
            showMapFieldOptions: false,
            showCustomFieldsDropdownForJobNumber: false,
            syncedFieldOptions: [],
            selectedFieldItem: null,
            selectedFieldIndex: null,
            loadingDropdownOptionsMessage: 'Fetching dropdown options',
            editingModuleFieldIndex: null,
            selectedModuleForImport: null,
            isAddButtonDisabled: false,
            fieldMappingNote: '',
            selectedMappingDropdownField : {
                followUpLabel: '',
                thirdParty: '',
            },
            followUpDropdownOptions: [],
            thirdPartyDropdownOptions: [],
            // usersList: [],
            moduleFieldDropdowns: [],
            selectedDropdownFieldIndex: null,
            erpOneWayFields: erpOneWayFields,
            fieldToHide: erpFieldsToHide
        };
    },
    watch: {

    },
    async mounted() {
        this.getProjectCustomFields();
        this.getRecordDetailCustomFields();
        this.getCompanyCustomFields();
        this.getContactCustomFields();
        this.getChangeOrderCustomFields();
        this.getSalesBehaviors();

        // get dropdowns options from api call to followup
        // this.getTeamUsers();
        await this.getErpIntegrations();

        // if(this.connectedErpIntegration === 'vista'){
        //     this.thirdPartyObjects = this.vistaObjectOption
        // }else{
        //     this.thirdPartyObjects = this.spectrumObjectOption
        //
        // }

        if(this.connectedErpIntegration === 'vista' && (this.selectedModule.direction === 'two-ways' || this.selectedModule.direction === 'one-way-followup' || this.selectedModule.direction === 'one-way-third-party')){
            this.selectedModule.directionUrl = this.bucketUrl+'erp/'+this.selectedModule.direction+'-latest.png';
        }

        this.thirdPartyObjects = this.objectOptions[this.connectedErpIntegration];
        this.followUpObjects = this.getFollowUpObjects();

        $(document).ready(function() {
            $(".import-button-disabled").tooltip();
            $(".tooltips-direction-class").tooltip();
            $(".checkbox-status-disabled-tooltip").tooltip();
        });
        this.addToolTip();
    },

    methods: {

        // returns s3 urls for the direction images
        returnUrl(val){
            return this.bucketUrl+'erp/'+val+'.png';
        },
        returnToolTip(val){
            let msg = 'Message';
            if (val === 'one-way-followup'){
                msg = 'The individual field mapping direction cannot be changed as the main module direction is set to One way - '+(this.connectedErpIntegration == 'foundationNew' ? 'foundation': this.connectedErpIntegration == 'vista' ? 'Vista' : 'Spectrum')+' to Followup';
            }
            if (val === 'one-way-third-party'){
                msg = 'The individual field mapping direction cannot be changed as the main module direction is set to One way - Followup To '+(this.connectedErpIntegration == 'foundationNew' ? 'foundation':this.connectedErpIntegration == 'vista' ? 'Vista' : 'Spectrum')+'';
            }
            return msg;
        },
        returnUrlDirection(val){
            if (val === 'two-ways' || val === 'one-way-followup' || val === 'one-way-third-party'){
                this.selectedModule.directionUrl = this.bucketUrl+'erp/'+val+'-latest.png';
            }else {
                this.selectedModule.directionUrl = this.bucketUrl+'erp/'+val+'.png';
            }
            $('#directionModuleUrl').attr('src', this.selectedModule.directionUrl);
        },
        returnUrlHover(val){
            this.selectedModule.directionUrl = this.bucketUrl+'erp/'+val+'-hover.png';
            $('#directionModuleUrl').attr('src', this.selectedModule.directionUrl);
        },

        returnUrlDirectionField(val, index){
            if (val.direction === 'two-ways' || val.direction === 'one-way-followup' || val.direction === 'one-way-third-party'){
                val.directionUrl = this.bucketUrl+'erp/'+val.direction+'-latest.png';
            }else {
                val.directionUrl = this.bucketUrl+'erp/'+val.direction+'.png';
            }
            $('#directionModuleUrlField'+val.id+'-'+index).attr('src', val.directionUrl);
        },
        returnUrlHoverField(val, index) {
            val.directionUrl = this.bucketUrl+'erp/'+val.direction+'-hover.png';
            $('#directionModuleUrlField'+val.id+'-'+index).attr('src', val.directionUrl);
        },

        formattedLabel(fieldItem, labelName = null) {
            let label = labelName ? labelName.replace(/_/g, ' ') : fieldItem.thirdPartyLabel.replace(/_/g, ' ');
            if (this.connectedErpIntegration === 'vista') {
                label = label.replace(/([A-Z])(?=[a-z])/g, ' $1').replace(/([a-z])(?=[A-Z])/g, '$1 ').trim()
            }

            return label;
        },

        getProjectCustomFields(){
            let self = this;
            let params = `?project=true`;
            axios.get(route('api.project-custom-field.index') + params).then(({data}) => {
                if(data.data.length){

                    this.projectTextCustomFields = data.data.filter(field => field.type === 2);
                    this.selectedProjectTextCustomField = this.projectTextCustomFields.filter(field => field.show_spectrum_job_number == 1)[0]?.id || null;

                    data.data.map(field =>{
                        self.followUpFields.projectCustomFields.push({
                                id:field.id,
                                value:field.id,
                                label: field.label_value,
                                disabled: false,
                                is_custom_field: true,
                                is_record_detail_custom_field: false,
                                is_dropdown_field: [1,3].includes(field.type),
                                fieldType: field.type,
                                options: [],
                                object_type: 'Project'
                            });
                    });
                }

            });
        },

        getCompanyCustomFields(){
            let self = this;
            let params = `?company=true`;
            axios.get(route('api.company-custom-field.index') + params).then(({data}) => {
                if(data.data.length){
                    data.data.map(field =>{
                        self.followUpFields.companyCustomFields.push({
                            id:field.id,
                            value:field.id,
                            label: field.label_value,
                            disabled: false,
                            is_custom_field: true,
                            is_record_detail_custom_field: false,
                            is_dropdown_field: [1,3].includes(field.type),
                            fieldType: field.type,
                            options: [],
                            object_type: 'Company'
                        });
                    });
                }
            });
        },

        getContactCustomFields(){
            let self = this;
            let params = `?contact=true`;
            axios.get(route('api.contact-custom-field.index') + params).then(({data}) => {
                if(data.data.length){
                    data.data.map(field =>{
                        self.followUpFields.contactCustomFields.push({
                            value:field.id,
                            label: field.label_value,
                            disabled: false,
                            is_custom_field: true,
                            is_record_detail_custom_field: false,
                            is_dropdown_field: [1,3].includes(field.type),
                            fieldType: field.type,
                            options: [],
                            object_type: 'CompanyContact'
                        });
                    });
                }
            });
        },

        getChangeOrderCustomFields(){
            let self = this;
            let params = `?changeOrder=true`;
            axios.get(route('api.change-order-custom-field.index') + params).then(({data}) => {
                if(data.data.length){
                    data.data.map(field =>{
                        self.followUpFields.changeOrderCustomFields.push({
                            value:field.id,
                            label: field.label_value,
                            disabled: false,
                            is_custom_field: true,
                            is_record_detail_custom_field: false,
                            is_dropdown_field: [1,3].includes(field.type),
                            fieldType: field.type,
                            options: [],
                            object_type: 'ProjectChangeOrder'
                        });
                    });
                }
            });
        },

        getSalesBehaviors(){
            let self = this;
            axios.get(route('api.erp-integration.get-sales-behaviors')).then(({data}) => {
                if(data.data.length){
                    data.data.map(salesBehavior =>{
                        self.followUpFields.salesBehaviors.push({
                                id:salesBehavior.id,
                                label: salesBehavior.name,
                                value: salesBehavior.id,
                                object_type:'Project',
                                disabled: false,
                                is_custom_field: false,
                                is_record_detail_custom_field: false,
                                is_dropdown_field: false,
                                is_sales_behavior:true,
                                options: null,
                            });
                    });
                }

            });
        },

        // getTeamUsers() {
        //     axios.get(route('api.team-users')).then(({data}) => {
        //         this.usersList = data.map(user => ({id: user.id, name: user.name}));
        //     });
        // },

        async getErpIntegrations(){
            const self = this;
            await axios.get(route('api.erp-integration.get',{third_party_name: this.connectedErpIntegration})).then( async ({data}) => {
                if(data){
                    self.erpIntegrationId = data.id;
                    // self.direction = data.direction
                    self.selectedSourceTruth = data.source_truth
                    self.syncStatus = data.sync_status

                    if(self.moduleMappings.length > 0){

                        self.moduleMappings = self.moduleMappings
                            .filter(moduleMap => {
                                const matchedField = _.find(data.fields, field => (field.follow_up_object === moduleMap.followUp && field.third_party_object === moduleMap.thirdParty));
                                return !!matchedField; // Only include objects where a matching field is found
                            })
                            .map(moduleMap => {
                                const matchedField = _.find(data.fields, field => (field.follow_up_object === moduleMap.followUp && field.third_party_object === moduleMap.thirdParty));
                                const parsedFieldJson = JSON.parse(matchedField.field_json);
                                moduleMap.erp_integration_id = matchedField.erp_integration_id;
                                moduleMap.id = matchedField.id;
                                moduleMap.followUp = matchedField.follow_up_object;
                                moduleMap.followUpCustomId = parsedFieldJson.followUpCustomId;
                                moduleMap.direction = matchedField.direction;
                                moduleMap.thirdParty = matchedField.third_party_object;
                                moduleMap.thirdPartyCustomId = parsedFieldJson.thirdPartyCustomId;
                                moduleMap.thirdPartyLabel = matchedField.third_party_label;
                                moduleMap.status = !!matchedField.status;
                                moduleMap.fieldMappings = matchedField.module_fields ? this.formatModuleFields(matchedField.module_fields, parsedFieldJson) : [];

                                return moduleMap;
                            });


                    }else{
                        self.moduleMappings = await data.fields.map(val => {
                            const parsedFieldJson = JSON.parse(val.field_json);
                            return {
                                erp_integration_id: val.erp_integration_id,
                                id: val.id,
                                followUp: val.follow_up_object,
                                followUpCustomId: parsedFieldJson.followUpCustomId,
                                direction: val.direction,
                                thirdParty: val.third_party_object,
                                thirdPartyCustomId: parsedFieldJson.thirdPartyCustomId,
                                thirdPartyLabel: val.third_party_label,
                                status: !!val.status,
                                fieldMappings: val.module_fields ? this.formatModuleFields(val.module_fields, parsedFieldJson) : []
                            }
                        })
                    }
                }

            });
        },

        // to add new row to erpIntegration modules
        async addModuleMapping() {
            const self = this;
            const followUpResult = this.followUpObjects.filter(val => val.disabled !== true);
            if(followUpResult.length > 0){
                await self.moduleMappings.push({
                    erp_integration_id: self.erpIntegrationId,
                    id: 0,
                    followUp: null,
                    followUpCustomId: null,
                    direction: this.direction,
                    thirdParty: null,
                    thirdPartyCustomId: null,
                    thirdPartyLabel: null,
                    status: false,
                    fieldMappings: []
                })
            }

            $(".checkbox-status-disabled-tooltip").tooltip();
        },

        // to save/create an erp module in DB
        saveModule(data) {
            // if((this.connectedErpIntegration === 'vista') || (this.connectedErpIntegration === 'spectrum' && data.fieldMappings.length > 0)){
                const self = this;

                self.isAddButtonDisabled = true;
                let payload =  {
                    erp_integration_id : self.erpIntegrationId,
                    data:data
                }
                axios.post(route('api.erp-integration-fields.create'), payload).then(({data}) => {
                    self.getErpIntegrations();
                    self.isAddButtonDisabled = false;
                });
            // }
        },

        updateModuleStatus(item){
            let payload =  {
                status : !item.status,
                erp_integration_field_id : item.id,
                erp_integration_id : item.erp_integration_id,
            }
            if(item.id == 0){
                return false
            }
            axios.post(route('api.erp-integration-fields.update'), payload).then(({data}) => {
                this.getErpIntegrations();
            });
        },
        checkDisabledModuleStatus(data) {
            return !this.checkMappedModuleStatus(data);
        },
        // to delete the module form DB
        async deleteModule(item) {
            let self = this;
            let payload =  {
                erp_integration_id : self.erpIntegrationId,
                field_id : item.id
            }
            await axios.post(route('api.erp-integration-fields.delete'), payload).then(async ({data}) => {
                await self.getErpIntegrations(item.id);
                const objectOptionIndex = self.followUpObjects.findIndex(val => val.value === item.followUp);
                if(objectOptionIndex !== -1){
                    self.followUpObjects[objectOptionIndex].disabled = false;
                }
            });

            $(".checkbox-status-disabled-tooltip").tooltip();
        },

        //this will disable the selected object type
        disabledModuleOption(data) {
            let self = this;
            self.followUpObjects = self.followUpObjects.map(option => ({...option, disabled: false}));
            self.thirdPartyObjects = self.thirdPartyObjects.map(option => ({...option, disabled: false}));
            data.map(item => {
                const followUpOptionIndex = self.followUpObjects.findIndex(option => option.custom_id === item.followUpCustomId)
                if(followUpOptionIndex !== -1){
                    self.followUpObjects[followUpOptionIndex].disabled = true
                }
                const thirdPartyOptionIndex = self.thirdPartyObjects.findIndex(thirdPartyOption => thirdPartyOption.custom_id === item.thirdPartyCustomId)
                if(thirdPartyOptionIndex !== -1){
                    self.thirdPartyObjects[thirdPartyOptionIndex].disabled = true
                }
            })
        },

        changeModule(data, type, index){
            if (type === 'followup') {
                if (data.followUp === 'Project' && data.thirdParty && data.thirdParty !== 'Jobs' ) {
                    this.getToast(2000).fire({
                        type: 'error',
                        title: 'Project can only be mapped to Jobs'
                    });
                    this.moduleMappings[index].followUp = null;
                    this.moduleMappings[index].followUpCustomId = null;

                } else {
                    this.moduleMappings[index].followUp = data.followUp;
                    this.moduleMappings[index].followUpCustomId = this.followUpObjects.find(option => option.value === data.followUp).custom_id;
                }
            } else {

                if (data.thirdParty === 'Jobs' && data.followUp && data.followUp !== 'Project') {
                    this.getToast(2000).fire({
                        type: 'error',
                        title: 'Jobs can only be mapped to Projects'
                    });
                    this.moduleMappings[index].thirdParty = null;
                    this.moduleMappings[index].thirdPartyCustomId = null;
                } else {
                    this.moduleMappings[index].thirdParty = data.thirdParty;
                    this.moduleMappings[index].thirdPartyCustomId = this.thirdPartyObjects.find(option => option.value === data.thirdParty && !option.disabled).custom_id;
                    this.moduleMappings[index].thirdPartyLabel = this.thirdPartyObjects.find(option => option.value === data.thirdParty).label;

                }
            }

            if (this.moduleMappings[index].thirdParty != null && this.moduleMappings[index].followUp != null) {
                this.saveModule(data);
            }
        },

        getValueByKey(key,thirdParty) {
            if (this.connectedErpIntegration === 'spectrum' && spectrumFieldLabelsMapping[thirdParty]) {
                const spectrumTableFields = spectrumFieldLabelsMapping[thirdParty]
                if (key in spectrumTableFields) {
                    return spectrumTableFields[key];
                } else {
                    return key.replace(/_/g, " ");
                }
            } else {
                return key;
            }
        },
        async viewFieldsMapping(item, index){
            let self = this;
            this.addToolTip();
            self.showFieldsMapping = true;
            self.fieldMappingError = null;
            self.fieldMappingNote = '';
            self.loadingMessage = 'Fetching fields';

            if(!item.followUp || !item.thirdParty){
                self.selectedModuleFieldMappings = []
                self.fieldMappingError = 'Modules are required';
                return false;
            }
            self.$nextTick(() => {
                $("#loadingOverlayFetchVistaFields").fadeIn();
            })
            this.selectedModule = item;
            this.selectedModuleIndex = index;
            this.selectedModule.directionUrl = this.returnUrl(item.direction+'-latest');
            this.selectedModule.erp_integration_id = item.erp_integration_id;
            this.selectedModule.erp_integration_field_id = item.id;


            if(this.selectedModule.followUp === 'Project'){
                this.followUpFieldsOptions = [{
                    label: 'Project Fields',
                    options: this.followUpFields.projectFields
                },{
                    label: 'Project Contact',
                    options: this.followUpFields.projectContact
                },{
                    label: 'Custom Fields',
                    options: this.followUpFields.projectCustomFields
                },{
                    label: 'Record Details Custom Fields',
                    options: this.followUpFields.recordDetailCustomFields
                },{
                    label: 'Sales Behaviors',
                    options: this.followUpFields.salesBehaviors
                }]

            }else if(this.selectedModule.followUp === 'Residential-contact'){
                this.followUpFieldsOptions = [{
                    label: 'Contact Fields',
                    options: this.connectedErpIntegration==='foundationNew' ? [ ...this.followUpFields.companyContactExtendedFields ,...this.followUpFields.contactFields, ...this.followUpFields.residentialContactFields] : [...this.followUpFields.contactFields, ...this.followUpFields.residentialContactFields]
                }, {
                    label: 'Custom Fields',
                    options: this.followUpFields.contactCustomFields
                }];

            }else if(this.selectedModule.followUp === 'Company'){
                this.followUpFieldsOptions = [{
                    label: 'Company Fields',
                    options: this.connectedErpIntegration==='foundationNew' ? [ ...this.followUpFields.companyExtendedFields , ...this.followUpFields.companyFields]: this.followUpFields.companyFields
                }, {
                    label: 'Contact Fields',
                    options: this.followUpFields.contactFields
                }, {
                    label: 'Custom Fields',
                    options: this.followUpFields.companyCustomFields
                }];

            }else if(this.selectedModule.followUp === 'Project-change-order'){
                this.followUpFieldsOptions = [{
                    label: 'Change Order',
                    options: this.followUpFields.projectChangeOrderFields
                }];

                this.followUpFieldsOptions.push({
                    label: 'Custom Fields',
                    options: this.followUpFields.changeOrderCustomFields
                });
            }


            let payload = {
                'tableName': item.thirdParty,
                'service': self.connectedErpIntegration
            }
            await axios.post(route('api.erp-integration-vista-spectrum-fields.get'), payload).then(({data}) => {
                    if(data.thirdPartyKeys){
                        self.thirdPartyFields = [];
                        const fieldsFromAgave = self.agaveFields[self.selectedModule?.thirdParty] ?? [];
                        data.thirdPartyKeys.sort().forEach(key => {
                            const matchingField = fieldsFromAgave.find(field => field.value === key);

                            const fieldValue = matchingField ? matchingField.value : key;
                            const fieldLabel = matchingField ? matchingField.label : key;

                            self.thirdPartyFields.push({
                                value: fieldValue,
                                label: fieldLabel,
                                labelFormatted: fieldLabel,
                                disabled: false,
                                direction: 'one-way-followup',
                                canChangeDirection:  false,
                                is_dropdown_field: matchingField?.is_dropdown_field ?? false,
                                options: null,
                            });
                        });

                        if (self.selectedModule.thirdParty === 'CE_jobs') {
                            self.thirdPartyFields = self.thirdPartyFields.filter(item => {
                                return !self.fieldToHide[self.selectedModule.thirdParty].includes(item.value)
                            });
                        }

                        $("#loadingOverlayFetchVistaFields").fadeOut();

                    }else if(data.error){
                        self.getToast(3000).fire({
                            type: 'error',
                            title: data.error
                        });
                    }
                });

            this.resetToolTip();

            this.selectedModuleFieldMappings = [];
            const requiredFields = self.agaveFields[self.selectedModule.thirdParty].filter(field => field.required);

            if(this.selectedModule.fieldMappings.length > 0) {
                this.selectedModule.fieldMappings.map(mappedField => {
                    this.selectedModuleFieldMappings.push({
                        erp_integration_field_id: mappedField.erp_integration_field_id,
                        id: mappedField.id,
                        // followUp: { value: mappedField.follow_up_field, label :mappedField.follow_up_field_label, object_type:mappedField.follow_up_object_type,  is_custom_field: mappedField.is_custom_field ?? 0},
                        followUp: mappedField.followUp,
                        followUpLabel: mappedField.followUpLabel,
                        followUpObject: mappedField.followUpObject,
                        direction: mappedField.direction,
                        thirdPartyLabel: mappedField.thirdPartyLabel,
                        thirdParty: mappedField.thirdParty,
                        status: !!mappedField.status,
                        is_custom_field: !!mappedField.is_custom_field,
                        is_record_detail_custom_field: !!mappedField.is_record_detail_custom_field,
                        is_dropdown_field: mappedField?.is_dropdown_field ?? this.isDropdownField(mappedField),
                        is_third_party_dropdown_field: mappedField?.is_third_party_dropdown_field ?? this.isThirdPartyDropdownField(mappedField),
                        dropdownMappings: mappedField.dropdownMappings ?? [],
                        is_custom_field_synced: !!mappedField.is_custom_field_synced,
                        canChangeDirection: this.userCanChangeDirection(mappedField),
                        directionUrl: this.returnUrl(mappedField.direction+'-latest')
                    })
                });

                const missingRequiredFields = requiredFields
                    .filter(obj1 => !this.selectedModule.fieldMappings.some(obj2 => obj1.value === obj2?.thirdParty))
                    .map(obj => obj.value);

                const finalRequiredFields = requiredFields.filter(field => missingRequiredFields.includes(field.value));
                this.manageRequiredFieldSelection(finalRequiredFields);
            }
            else {
                if(requiredFields.length > 0) {
                    this.manageRequiredFieldSelection(requiredFields);
                }
            }

            if(self.selectedModule.thirdParty && self.selectedModule.followUp){
                const requiredFields = self.agaveFields[self.selectedModule.thirdParty].filter(field => field.required);
                if(requiredFields.length > 0){
                    self.fieldMappingNote = 'Note: Required fields by '+ this.capitalizeText(self.connectedErpIntegrationName) +' ('+ requiredFields.map(field => this.formattedLabel(null, field.label)).join(", ")+')';
                }
            }

        },

        // to add new row to module field mappings
        async addModuleFieldMappingData() {
            const self = this;
            // if (self.connectedErpIntegration !== 'vista'){
            //     await self.disabledModuleFieldOption(self.selectedModuleFieldMappings)
            // }
            const followUpFieldResult = self.computedFollowUpFields.filter(val => val.disabled !== true);
            const thirdPartyFieldResult = self.thirdPartyFields.filter(val => val.disabled !== true);
            if(followUpFieldResult.length > 0 && thirdPartyFieldResult.length > 0){
                self.selectedModuleFieldMappings.push({
                    erp_integration_field_id: self.selectedModule.id,
                    id: 0,
                    followUp: {value: null, label: null, object_type: null, disabled: false, is_custom_field: 0, is_record_detail_custom_field: 0},
                    followUpLabel: null,
                    followUpObject: null,
                    direction: this.fieldDirection,
                    thirdPartyLabel: null,
                    thirdParty: null,
                    status: true,
                    is_custom_field: false,
                    is_record_detail_custom_field: false,
                    is_third_party_dropdown_field: false,
                    is_custom_field_synced: false,
                    is_dropdown_field: false,
                    dropdownMappings: [],
                })
            }
        },

        isDropdownField(item) {
            return this.followUpFieldsOptions.some(group => {
                const matchingField = group.options.find(field => field.value === item.followUp.value && field.is_dropdown_field);
                return !!matchingField;
            });
        },

        isThirdPartyDropdownField(item) {
            return !!this.thirdPartyFields.some(field => field.value === item.third_party_field && field.is_dropdown_field);
        },

        changeFields(data, type, index){
            let self = this;
            if(this.selectedModule.followUp === "Project" || this.selectedModule.followUp === "Project-change-order"){
               let fieldMappedFound = this.selectedModuleFieldMappings.find(res => res.thirdParty === "number" &&
                   (["job_number","id"].includes(res.followUp.value) || (res.followUp.is_custom_field && res.followUp.fieldType == 2)));
               if(this.connectedErpIntegration === 'foundationNew' && this.selectedModule.followUp === "Project"){
                   if(fieldMappedFound !==undefined){
                       self.setFieldValues(data, type, index);
                   }
                   else{
                       if(type === 'followup'){
                           if(data.followUp.value !=="job_number" && data.followUp.value !=="id" &&   data.followUp.fieldType !==2){
                               if(data.thirdParty && data.thirdParty === 'number'){
                                   self.getToast(3000).fire({
                                       type: 'error',
                                       title: 'Job # needs to be mapped to either Seq Project ID,Autogenerate or Custom field type text'
                                   });
                                   self.resetFieldValues(type,index);
                               }else{
                                   self.setFieldValues(data, type, index);
                               }
                           }else if(data.followUp.value ==="job_number" || data.followUp.value ==="id" || data.followUp.fieldType ===2){
                               if(data.thirdParty && data.thirdParty !== 'number'){
                                   self.getToast(3000).fire({
                                       type: 'error',
                                       title: 'Job # needs to be mapped to either Seq Project ID,Autogenerate or Custom field type text'
                                   });
                                   self.resetFieldValues(type,index);
                               }else{
                                   self.setFieldValues(data, type, index);
                               }
                           }else{
                             self.setFieldValues(data, type, index);
                           }
                       }
                       else{
                           if(data.thirdParty !== 'number'){
                               if(data.followUp.value && (data.followUp.value ==="job_number" || data.followUp.value ==="id" || data.followUp.fieldType ===2)){
                                   self.getToast(3000).fire({
                                       type: 'error',
                                       title: 'Job # needs to be mapped to either Seq Project ID,Autogenerate or Custom field type text'
                                   });
                                   self.resetFieldValues(type,index);
                               }else{
                                   self.setFieldValues(data, type, index);
                               }
                           }else{
                             self.setFieldValues(data, type, index);
                           }
                       }
                   }
               }else{
                   self.setFieldValues(data, type, index);
               }
            }
            if(this.selectedModule.followUp === "Company" || this.selectedModule.followUp === "Residential-contact"){
                if(type === 'followup'){
                    if(this.connectedErpIntegration === 'foundationNew' && (data.followUp.value !=="customer_number" && data.followUp.value !=="id" && data.followUp.fieldType !==2)){
                        if(data.thirdParty && data.thirdParty === 'code'){
                            self.getToast(3000).fire({
                                type: 'error',
                                title: 'Customer # needs to be mapped to either Seq Company ID,Autogenerate or Custom field type text'
                            });
                            self.resetFieldValues(type,index);
                        }else{
                            self.setFieldValues(data, type, index);
                        }
                    }else if(this.connectedErpIntegration === 'foundationNew' && (data.followUp.value ==="job_number" || data.followUp.value ==="id" ||  data.followUp.fieldType ===2)){
                        if(data.thirdParty && data.thirdParty !== 'code'){
                            self.getToast(3000).fire({
                                type: 'error',
                                title: 'Customer # needs to be mapped to either Seq Company ID,Autogenerate or Custom field type text'
                            });
                            self.resetFieldValues(type,index);
                        }else{
                            self.setFieldValues(data, type, index);
                        }
                    }else{
                        self.setFieldValues(data, type, index);
                    }
                }
                else{
                    if(data.thirdParty !== 'code' && this.connectedErpIntegration === 'foundationNew'){
                        if(data.followUp.value && (data.followUp.value ==="customer_number" || data.followUp.value ==="id" ||  data.followUp.fieldType ===2)){
                            self.getToast(3000).fire({
                                type: 'error',
                                title: 'Customer # needs to be mapped to either Seq Company ID,Autogenerate or Custom field type text'
                            });
                            self.resetFieldValues(type,index);
                        }else{
                            self.setFieldValues(data, type, index);
                        }
                    }else{
                        self.setFieldValues(data, type, index);
                    }
                }
            }
            this.fieldMappingError = null;
            // if (this.connectedErpIntegration !== 'vista'){
            //     this.disabledModuleFieldOption(this.selectedModuleFieldMappings);
            // }
        },
        setFieldValues(data, type, index) {
            if(type === 'followup') {
                let followUpSelectedOption = data.followUp;
                this.selectedModuleFieldMappings[index].is_custom_field = followUpSelectedOption.is_custom_field;
                this.selectedModuleFieldMappings[index].is_record_detail_custom_field = followUpSelectedOption.is_record_detail_custom_field;
                this.selectedModuleFieldMappings[index].is_dropdown_field = followUpSelectedOption.is_dropdown_field;
                this.selectedModuleFieldMappings[index].dropdownMappings = [];
                this.selectedModuleFieldMappings[index].followUpLabel = followUpSelectedOption.label;
                this.selectedModuleFieldMappings[index].followUpObject = followUpSelectedOption.object_type;
            }else{
                const thirdPartySelectedOption = this.thirdPartyFields.find(option => option.value === data.thirdParty)
                this.selectedModuleFieldMappings[index].thirdParty = data.thirdParty;
                this.selectedModuleFieldMappings[index].thirdPartyLabel = thirdPartySelectedOption.label;
                this.selectedModuleFieldMappings[index].is_third_party_dropdown_field = thirdPartySelectedOption.is_dropdown_field;
                this.selectedModuleFieldMappings[index].direction = thirdPartySelectedOption.direction;
                this.selectedModuleFieldMappings[index].canChangeDirection = thirdPartySelectedOption.canChangeDirection;
                this.selectedModuleFieldMappings[index].directionUrl = this.returnUrl(thirdPartySelectedOption.direction+'-latest');
            }
        },
        resetFieldValues(type,index){
            if(type === 'followup'){
                this.selectedModuleFieldMappings[index].is_custom_field = false;
                this.selectedModuleFieldMappings[index].is_record_detail_custom_field = false;
                this.selectedModuleFieldMappings[index].is_dropdown_field = false;
                this.selectedModuleFieldMappings[index].dropdownMappings = [];
                this.selectedModuleFieldMappings[index].followUpLabel = null;
                this.selectedModuleFieldMappings[index].followUpObject = null;
                this.selectedModuleFieldMappings[index].followUp = null;
            }else{
                this.selectedModuleFieldMappings[index].thirdParty = null;
                this.selectedModuleFieldMappings[index].thirdPartyLabel = null;
                this.selectedModuleFieldMappings[index].is_third_party_dropdown_field = false;
            }

        },
        // to update the erp module fields in DB
        async updateModule(data) {
            const self = this;
            let thirdPartyObject = data.thirdParty;
            let payload =  {
                data: data
            }
            await axios.post(route('api.erp-integration-fields.update-vista-module'), payload).then(({data}) => {
                self.getErpIntegrations();
                let allThirdPartyFields =  data.fields.find(field => field.third_party_object == thirdPartyObject);
                self.showSaveFieldsButton = false;
                if (allThirdPartyFields && allThirdPartyFields.module_fields.length > 0) {
                    if (self.fieldMappingError === null) {
                        self.getToast(3000).fire({
                            type: 'success',
                            title: self.moduleMappingSuccessMsg
                        });
                    }
                }


            });
        },

        // to complete adding the module field to selectedModuleFieldMappings
        async addModuleField(index) {
            const fieldObject = this.selectedModuleFieldMappings[index];
            if(!fieldObject.followUp?.value || !fieldObject.thirdParty){
                this.fieldMappingError = 'Please map a field on both sides in order to save.';
                return false;
            }
            this.selectedModuleFieldMappings[index].id = index+1;

            if(!this.showSaveFieldsButton){
                this.showSaveFieldsButton = true;
            }
            this.fieldMappingError = null;
            this.editingModuleFieldIndex = false
        },
        onModalHide() {
            this.addToolTip();
            if (this.showFieldsMapping) {
                this.saveModuleFields();
            }
        },
        // to push the module field to module.fieldMappings
        async saveModuleFields() {
            let self = this;

                self.moduleMappings[self.selectedModuleIndex].fieldMappings = self.selectedModuleFieldMappings.filter(field => field.followUpLabel && field.thirdPartyLabel);

                self.showFieldsMapping = false;
                self.selectedModuleFieldMappings = [];
                // if (self.connectedErpIntegration !== 'vista'){
                //     await self.disabledModuleFieldOption(self.selectedModuleFieldMappings);
                // }
                if(self.moduleMappings[self.selectedModuleIndex].id !== 0) {
                    self.moduleMappings[self.selectedModuleIndex].status = self.checkMappedModuleStatus(self.selectedModule);
                    await self.updateModule(self.moduleMappings[self.selectedModuleIndex]);
                }

                this.editingModuleFieldIndex = null;
            // }
        },

        editModuleField(index){
            this.editingModuleFieldIndex = index;
        },

        // to remove the module field from selectedModuleFieldMappings while editing
        async removeModuleField(index) {
            // await this.removeDisabledFieldOption(this.selectedModuleFieldMappings[index]);
            this.selectedModuleFieldMappings.splice(index, 1);
            this.showSaveFieldsButton = true;
            this.editingModuleFieldIndex = null;
        },

        disabledModuleFieldOption(data){
            this.thirdPartyFields = this.thirdPartyFields.map(option => ({...option, disabled: false}));
            for (let j = 0; j < data.length; j++) {

                const thirdPartyFieldOptionIndex = this.thirdPartyFields.findIndex(item => item.value === data[j].thirdParty);
                if(thirdPartyFieldOptionIndex !== -1){
                    this.thirdPartyFields[thirdPartyFieldOptionIndex].disabled = true;
                }
            }
        },


        userCanChangeDirection(fieldItem){
            if((this.connectedErpIntegration === 'vista') && this.selectedModule.followUp === 'Project-change-order'){
                return false;
            }else{
                return !!this.agaveFields[this.selectedModule.thirdParty].some(field => field.value === fieldItem.thirdParty && (!this.erpOneWayFields[this.selectedModule.thirdParty] || !this.erpOneWayFields[this.selectedModule.thirdParty].includes(fieldItem.thirdParty)));
            }
        },

        removeDisabledFieldOption(data){
            const followupFieldOptionIndex = this.followUpFieldsOptions.findIndex(item => item.value === data.followUp);
            if(followupFieldOptionIndex !== -1){
                this.followUpFieldsOptions[followupFieldOptionIndex].disabled = false;
            }
            const thirdPartyFieldOptionIndex = this.thirdPartyFields.findIndex(item => item.value === data.thirdParty);
            if(thirdPartyFieldOptionIndex !== -1){
                this.thirdPartyFields[thirdPartyFieldOptionIndex].disabled = false;
            }
        },

        // to change the direction of the module FollowUp to ThirdParty etc.
        changeModuleDirection(){
            // if(this.selectedModule.followUp == 'Project-change-order' && this.connectedErpIntegration == 'spectrum'){
            //     this.selectedModule.direction = 'one-way-followup';
            //     this.getToast().fire({
            //         type: 'error',
            //         title: 'Pushing  Change orders to Spectrum is not currently supported'

            //     });
            // }else{
                switch (this.selectedModule.direction) {
                    case 'two-ways':
                        this.selectedModule.direction = 'one-way-followup';
                        break;
                    case 'one-way-followup':
                        this.selectedModule.direction = 'one-way-third-party';
                        break;
                    case 'one-way-third-party':
                        this.selectedModule.direction = 'two-ways';
                        break;
                    default:
                        console.log(`Sorry, we are out`);
                }
                this.showSaveFieldsButton = true;
            // }

            // if (this.connectedErpIntegration == 'vista'){
                this.returnUrlDirection(this.selectedModule.direction);

                this.selectedModuleFieldMappings = _.map(this.selectedModuleFieldMappings, mappedField => {
                    mappedField.direction = this.userCanChangeDirection(mappedField) ? this.selectedModule.direction : mappedField.direction;
                    mappedField.canChangeDirection = this.userCanChangeDirection(mappedField);
                    mappedField.directionUrl = this.userCanChangeDirection(mappedField) ? this.returnUrl(this.selectedModule.direction + '-latest') : this.returnUrl(mappedField.direction + '-latest');
                    return mappedField;
                });


            // }
            this.resetToolTip();
        },

        // to change the direction of the module fields if the field has agave key
        changeModuleFieldDirection(fieldItem, index){
            switch (fieldItem.direction) {
                case 'two-ways':
                    fieldItem.direction = 'one-way-followup';
                    break;
                case 'one-way-followup':
                    fieldItem.direction = 'one-way-third-party';
                    break;
                case 'one-way-third-party':
                    fieldItem.direction = 'two-ways';
                    break;
                default:
                    console.log(`Sorry, we are out`);
            }
            this.returnUrlDirectionField(fieldItem, index);
            this.showSaveFieldsButton = true;
            this.resetToolTip();
        },

        getFollowUpObjects() {
            return this.objectOptions['follow_up'];
        },

        isFieldDisabled(selectedModuleFieldMappings, field){
            let isDisabled = field.disabled;
            selectedModuleFieldMappings.map(fieldMapping => {
                if(fieldMapping.followUpLabel && fieldMapping.followUp.label == field.label && fieldMapping.followUp.object_type == field.object_type){
                    isDisabled = true;
                }
            })
            return isDisabled;
        },

        formatModuleFields(moduleMappings, parsedJson = null){
            return moduleMappings.map(moduleMapping => {
                let matchedField = null;
                if(parsedJson){
                        matchedField = parsedJson.fieldMappings.find(field => field.thirdParty == moduleMapping.agave_field && field.thirdPartyLabel == moduleMapping.third_party_field && field.followUp.value == moduleMapping.follow_up_field)
                }
                return {
                    erp_integration_field_id: moduleMapping.erp_integration_field_id,
                    id: moduleMapping.id,
                    followUp: {value: moduleMapping.follow_up_field,
                        label: moduleMapping.follow_up_field_label,
                        object_type: moduleMapping.follow_up_object_type,
                        disabled: false,
                        is_custom_field: (moduleMapping.is_custom_field && moduleMapping.is_custom_field != 0) ? !!moduleMapping.is_custom_field : false,
                        fieldType: matchedField? matchedField.followUp.fieldType :null,
                        is_sales_behavior: matchedField ? (matchedField.followUp.is_sales_behavior ?? false) :(moduleMapping.is_sales_behavior ?? false),
                        is_project_contact: matchedField ? (matchedField.followUp.is_project_contact ?? false) :(moduleMapping.is_project_contact ?? false),
                        is_project_comment: matchedField ? (matchedField.followUp.is_project_comment ?? false) :(moduleMapping.is_project_comment ?? false),
                        is_record_detail_custom_field: (moduleMapping.is_record_detail_custom_field && moduleMapping.is_record_detail_custom_field != 0) ? !!moduleMapping.is_record_detail_custom_field : false,
                        options: [],
                        is_dropdown_field: matchedField? matchedField.is_dropdown_field : false
                    },
                    followUpLabel: moduleMapping.follow_up_field_label,
                    followUpObject: moduleMapping.follow_up_object_type,
                    direction: moduleMapping.direction,
                    thirdPartyLabel: moduleMapping.third_party_field,
                    thirdParty: moduleMapping.agave_field,
                    status: moduleMapping.status,
                    is_custom_field: moduleMapping.is_custom_field,
                    is_record_detail_custom_field: moduleMapping.is_record_detail_custom_field,
                    is_third_party_dropdown_field: matchedField? matchedField.is_third_party_dropdown_field : false,
                    is_custom_field_synced: false,
                    is_dropdown_field: matchedField? matchedField.is_dropdown_field : false,
                    dropdownMappings: matchedField?.dropdownMappings ?? [],
                }
            })
        },


        openImportCustomersModal(item){
            this.selectedModuleForImport = item.followUp;
            $("#importCustomerConfirmationModal").modal('show');
        },

        importCustomers(item){

            $("#importCustomerConfirmationModal").modal('hide');
            let self = this;
            axios.post(route('api.vista.import-customers', {type: this.selectedModuleForImport})).then(response => {
                if(response.data.status == "success"){
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: 'Something went wrong'

                    });
                }
            });

        },
        openImportJobsModal(){
            $("#importJobConfirmationModal").modal('show');
        },
        importFoundationJobs(updateJobs){
            $("#importJobFoundationConfirmationModal").modal('hide')
            let self = this;
            axios.post(route('api.foundation.import-jobs', {updateProjects: updateJobs})).then(response => {
                if(response.data.status == "success"){
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: 'Something went wrong'

                    });
                }
            });

        },

        importJobs(updateJobs){

            $("#importJobConfirmationModal").modal('hide');
            let self = this;
            let importRoute = 'api.computerEase.import-jobs';

            axios.post(route(importRoute, {updateProjects: updateJobs})).then(response => {
                if(response.data.status == "success"){
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: 'Something went wrong'

                    });
                }
            });

        },

        closeImportCustomersModal(){
            $("#importCustomerConfirmationModal").modal('hide');
        },

        showProjectCustomFieldDropdown(fieldItem) {
            this.showCustomFieldsDropdownForJobNumber = true;
            this.selectedMappingDropdownField = fieldItem;
        },

        markProjectCustomFieldToShowJobNumber(event) {
            axios.post(route('api.project-custom-field.mark-project-custom-field-as-erp-job-number-field', {projectCustomField : this.selectedProjectTextCustomField}), {integration: this.connectedErpIntegration}).then(({data}) => {

            })
        },

        mapDropdownFields(fieldItem, fieldIndex) {
            let self = this;
            self.showMapFieldOptions = true;
            self.selectedDropdownFieldIndex = fieldIndex;
            self.selectedMappingDropdownField = fieldItem;
            self.$nextTick(() => {
                $("#loadingOverlayFetchingFieldOptions").fadeIn();
            })

            self.moduleFieldDropdowns = [];
            self.thirdPartyDropdownOptions = [];
            self.followUpDropdownOptions = [];

            axios.post(route('api.erp-integration-vista-fields.get-project-manager'), {fieldItem: fieldItem, integration: this.connectedErpIntegration}).then(({data}) => {

                if(data.status == 'success'){
                    if(!data.followupFieldOptions || data.followupFieldOptions.length == 0){
                        this.getToast(2000).fire({
                            type: 'error',
                            title: 'No Data found for field '+fieldItem.followUpLabel
                        });
                    }else if(!data.agaveFieldOptions || data.agaveFieldOptions.length == 0){
                        this.getToast(2000).fire({
                            type: 'error',
                            title: 'No Data found for field '+fieldItem.thirdPartyLabel
                        });
                    }else{

                        self.followUpDropdownOptions = data.followupFieldOptions.map(option => ({ ...option, followup_field_id: option.id}));
                        self.thirdPartyDropdownOptions = data.agaveFieldOptions.map(option => ({ ...option, agave_field_id: option.id}));

                        if(self.followUpDropdownOptions.length > self.thirdPartyDropdownOptions.length ){
                            self.moduleFieldDropdowns = self.followUpDropdownOptions.map(field => { return {
                                followup_field_id : field.id,
                                follow_up_label : field.name,
                                agave_field_id : null,
                                third_party_label: null,
                            }})
                        }else{
                            if(this.connectedErpIntegration === 'foundationNew' && (this.selectedMappingDropdownField.thirdParty ==="number" && this.selectedMappingDropdownField.followUp.value === "job_number")){
                                let firstOption = null;
                                if(self.selectedMappingDropdownField?.dropdownMappings?.[0]?.agave_field_id){
                                     firstOption = self.thirdPartyDropdownOptions.find(val=>val.id === self.selectedMappingDropdownField?.dropdownMappings[0].agave_field_id);
                                }else{
                                    firstOption = self.thirdPartyDropdownOptions[0];
                                }
                                self.moduleFieldDropdowns = [{
                                    agave_field_id: firstOption.id,
                                    third_party_label: firstOption.name,
                                    followup_field_id: null,
                                }];
                            }else{
                                self.moduleFieldDropdowns = self.thirdPartyDropdownOptions.map(field => { return {
                                    agave_field_id : field.id,
                                    third_party_label: field.name,
                                    followup_field_id : null,
                                }})
                            }
                        }

                        if(self.selectedMappingDropdownField.dropdownMappings.length > 0){

                            self.moduleFieldDropdowns = self.moduleFieldDropdowns.map(moduleFieldDropdown => {
                                let matchedDropdown = self.selectedMappingDropdownField.dropdownMappings.find(dropdown => (dropdown.followup_field_id == moduleFieldDropdown.followup_field_id || dropdown.agave_field_id == moduleFieldDropdown.agave_field_id))
                                if(matchedDropdown){
                                    let thirdPartyMatchObject = self.thirdPartyDropdownOptions.find(thirdPartyDropdown=>thirdPartyDropdown.id == matchedDropdown.agave_field_id);
                                    if(thirdPartyMatchObject){
                                        return {...moduleFieldDropdown, followup_field_id: matchedDropdown.followup_field_id, agave_field_id: matchedDropdown.agave_field_id , third_party_label : thirdPartyMatchObject.name}
                                    }else{
                                        return {...moduleFieldDropdown, followup_field_id: matchedDropdown.followup_field_id, agave_field_id: matchedDropdown.agave_field_id}
                                    }

                                }else{
                                    return moduleFieldDropdown;
                                }

                            })
                            // self.moduleFieldDropdowns = self.selectedMappingDropdownField.dropdownMappings;

                        }
                    }



                    $("#loadingOverlayFetchingFieldOptions").fadeOut();
                }else{
                    self.thirdPartyDropdownOptions = [];
                    this.getToast(2000).fire({
                        type: 'error',
                        title: 'No Project Managers found on Vista'
                    });
                }
            });

        },

        changeDropdownMappingField(fieldIndex, option, type){

            if(type == 'follow_up'){
                this.moduleFieldDropdowns[fieldIndex].follow_up_label = this.followUpDropdownOptions.find(followUpOption => followUpOption.id == option.followup_field_id)?.name ?? ''
            }else{
                this.moduleFieldDropdowns[fieldIndex].third_party_label = this.thirdPartyDropdownOptions.find(thirdPartyOption => thirdPartyOption.id == option.agave_field_id)?.name ?? ''
            }
        },

        saveDropdownOptions() {
            let self = this;
            // if(self.moduleFieldDropdowns.some(moduleFieldDropdowns => !moduleFieldDropdowns.followup_field_id || !moduleFieldDropdowns.agave_field_id)){
            //     this.getToast(2000).fire({
            //         type: 'error',
            //         title: 'Some fields are not mapped'
            //     });
            //     return false;
            // }else{

                self.selectedModuleFieldMappings[self.selectedDropdownFieldIndex].dropdownMappings = self.moduleFieldDropdowns.filter(moduleFieldDropdown => moduleFieldDropdown.followup_field_id && moduleFieldDropdown.agave_field_id);
                self.showMapFieldOptions = false;
                self.selectedDropdownFieldIndex = null;
                self.selectedMappingDropdownField =  {
                    followUpLabel: '',
                    thirdParty: '',
                };
                self.followUpDropdownOptions = [];
                self.thirdPartyDropdownOptions = [];
                self.moduleFieldDropdowns = [];
                self.showSaveFieldsButton = true;
            // }
        },

        resetToolTip(){
            setTimeout(() => {
                $(".tooltips-direction-class").tooltip('dispose');
                $(".tooltips-direction-class").tooltip();
            }, 500)
        },
        getRecordDetailCustomFields() {
            let self = this;
            let params = `?project=true`;
            axios.get(route('api.record-detail-custom-field.index') + params).then(({data}) => {
                if(data.data.length) {
                    data.data.map(field => {
                        self.followUpFields.recordDetailCustomFields.push({
                            id: field.id,
                            value: field.id,
                            label: field.label_value,
                            disabled: false,
                            is_custom_field: false,
                            is_record_detail_custom_field: true,
                            is_dropdown_field: [1, 3].includes(field.type),
                            fieldType: field.type,
                            options: [],
                            object_type: 'Project'
                        });
                    });
                }
            });
        },
        capitalizeText(text) {
            return text
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        },
        manageRequiredFieldSelection(requiredFields) {
            if(this.connectedErpIntegration === 'vista' || this.connectedErpIntegration === 'spectrum' || this.connectedErpIntegration === 'foundationNew') {
                this.manageVistaRequiredFieldSelection(requiredFields);
            }
        },
        manageVistaRequiredFieldSelection(requiredFields) {
            let formattedObject = {
                id: 0,
                is_custom_field: false,
                is_record_detail_custom_field: false,
                is_custom_field_synced: false,
                is_dropdown_field: false,
                followUpLabel: null,
                followUpObject: null,
                followUp: {
                    value: null,
                    label: null,
                    object_type: null,
                    disabled: false,
                    is_custom_field: 0,
                    is_record_detail_custom_field: 0
                },
                erp_integration_field_id: this.selectedModule.id,
                status: true,
                dropdownMappings: []
            };

            requiredFields.forEach(field => {
                let thirdPartySelectedOption = this.thirdPartyFields.find(option => option.value === field.value)
                this.selectedModuleFieldMappings.push({
                    ...formattedObject,
                    thirdParty: field.value,
                    thirdPartyLabel: field.label,
                    is_third_party_dropdown_field: thirdPartySelectedOption?.is_dropdown_field ?? false,
                    direction: thirdPartySelectedOption?.direction ?? 'two-ways',
                    canChangeDirection: thirdPartySelectedOption?.canChangeDirection ?? false,
                    directionUrl: this.returnUrl((thirdPartySelectedOption?.direction ?? 'two-ways') +'-latest')
                });
            });
        },
        isFieldRequired(item) {
            let self = this;
            let status = false;

            const result = _.find(self.agaveFields[self.selectedModule.thirdParty], { value: item.thirdParty });
            status = result?.required ? true : status;

            // if(status) {
            //     const mappedField = _.findIndex(self.selectedModuleFieldMappings, { thirdParty: result.value });
            //     status = mappedField === -1
            // }

            return status;
        },
        isFieldRequiredToolTip(item) {
            return this.manageFieldDisableForRequiredFields(item) ? 'Required field cannot be deleted' : '';
        },
        addToolTip() {
            setTimeout(() => {
                $(".tooltip-delete-field-mapping").tooltip('dispose');
                $(".tooltip-delete-field-mapping").tooltip();
            }, 2000);
        },
        checkMappedModuleStatus(module) {
            if(module?.thirdParty) {
                const requiredFields = this.agaveFields[module.thirdParty].filter(field => field.required);
                if(requiredFields.length > 0) {
                    return requiredFields.every(obj1 =>
                        module.fieldMappings.some(obj2 => obj1.value === obj2.thirdParty)
                    );
                }
                else {
                    return module.fieldMappings.length > 0;
                }
            }
            return false;
        },
        manageModuleDeletion(module, index) {
            if(module.id === 0) {
                this.moduleMappings.splice(index, 1);
            }
            else {
                this.deleteModule(module);
            }
        },
        manageFieldDisableForRequiredFields(fieldItem) {
            const fieldOccurrences = [];
            const selectedMappings = this.selectedModuleFieldMappings;

            selectedMappings.forEach((mapping, index) => {
                if(this.isFieldRequired(mapping)) {
                    fieldOccurrences.push({ field: mapping.thirdParty, index });
                }
            });

            // Find the first occurrence index for the current field
            const firstOccurrence = fieldOccurrences.find(
                occurrence => occurrence.field === fieldItem.thirdParty
            );

            // Disable button if the current field is the first occurrence
            return firstOccurrence && selectedMappings[firstOccurrence.index] === fieldItem;
        },
    },
    computed: {
        // returns the FollowUp objects as per the selected erp integration
        computedFollowUpFields() {

            return this.followUpFieldsOptions.map(group => ({
                label: group.label,
                options: group.options.map(field =>{
                    let newLabel = field.label
                    if(field.value == 'job_number'){
                        if(this.connectedErpIntegration == 'spectrum'){
                            newLabel = "Auto-generated Job # based on Spectrum Job #";
                        }else{
                            newLabel = newLabel.replace('vista', this.connectedErpIntegration);
                        }
                    }
                    return {
                        label: newLabel,
                        value: {
                            value:field.value,
                            label: newLabel,
                            object_type: field.object_type,
                            is_custom_field: field.is_custom_field ?? 0,
                            is_record_detail_custom_field: field.is_record_detail_custom_field ?? 0,
                            is_dropdown_field: field.is_dropdown_field,
                            is_sales_behavior: field.is_sales_behavior ?? false,
                            is_project_contact: field.is_project_contact ?? false,
                            is_project_comment: field.is_project_comment ?? false,
                            fieldType: field.fieldType ?? null,
                            options: [],
                            disabled: false
                        },
                        disabled: false,
                    }
                })
            }));
        },
        connectedErpIntegrationName() {
            if(this.connectedErpIntegration === "foundationNew") {
                return 'foundation';
            }
            return this.connectedErpIntegration;
        },
        moduleMappingSuccessMsg() {
            let moduleName = this.selectedModule.followUp;
            if(['vSMServiceSite', 'vSMWorkOrder'].includes(this.selectedModule.thirdParty)) {
                moduleName = this.selectedModule.thirdPartyLabel;
            }
            return this.formatERPModuleName(moduleName) + ' mapping successfully saved';
        }
    },
}
</script>
<style scoped>
#loadingOverlayFetchVistaFields, #loadingOverlayFetchFieldOptions{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    display: none;
    background: rgb(0 0 0 / 57%);
}

.cv-spinner {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.spinner {
    width: 40px;
    height: 40px;
    border: 4px #ddd solid;
    border-top: 4px #2e93e6 solid;
    border-radius: 50%;
    animation: sp-anime 0.8s infinite linear;
}
img.and-logic-logo {
    width: 100%;
    max-width: 65px;
    height: auto;
    transition: all .3s linear;
    filter: invert(26%) sepia(89%) saturate(1583%) hue-rotate(95deg) brightness(96%) contrast(106%);
}
.mapping-table {
    max-height: 50vh;
    overflow: auto;
}
@keyframes sp-anime {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(359deg);
    }
}
.mt-18 {
    margin-top: 18px;
}
.mt-20 {
    margin-top: 20px;
}
.mt-17 {
    margin-top: 17px;
}
.disabled-opacity {
    opacity: 0.7;
}
.mt-50 {
    margin-top: 50px;
}
</style>
